<template>
  <trash-vue :active="selected"></trash-vue>
</template>

<script>
import TrashVue from '@common/Components/SVG/Trash.vue';
TrashVue;
export default {
  components: {
    TrashVue
  },
  props: {
    selected: Boolean
  }
};
</script>

<style>
</style>
